var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEiCustomToolPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.904 14.563C4.95718 14.8019 5.08215 15.0189 5.26214 15.1847C5.44214 15.3506 5.66855 15.4574 5.91101 15.491C6.15347 15.5245 6.40037 15.4831 6.61862 15.3722C6.83686 15.2614 7.016 15.0865 7.132 14.871L9.222 11.778L14.129 16.685C14.2281 16.7841 14.3457 16.8627 14.4752 16.9163C14.6046 16.9699 14.7434 16.9975 14.8835 16.9975C15.0236 16.9975 15.1624 16.9699 15.2918 16.9163C15.4213 16.8627 15.5389 16.7841 15.638 16.685L16.685 15.638C16.7841 15.5389 16.8627 15.4213 16.9163 15.2918C16.9699 15.1624 16.9975 15.0236 16.9975 14.8835C16.9975 14.7434 16.9699 14.6046 16.9163 14.4752C16.8627 14.3457 16.7841 14.2281 16.685 14.129L11.778 9.222L14.891 7.132C15.1065 7.01592 15.2814 6.8367 15.3921 6.61839C15.5029 6.40008 15.5442 6.15312 15.5106 5.91064C15.477 5.66816 15.37 5.44177 15.204 5.26184C15.038 5.08191 14.821 4.95704 14.582 4.904L1 1L4.904 14.563Z",
    fill: "var(--primaryA2)",
    stroke: "var(--primaryA1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiCustomToolPointer);
export default __webpack_public_path__ + "static/media/EICustomToolPointer.acc7180083f60e607cf5c9ac00275502.svg";
export { ForwardRef as ReactComponent };